const grantApplication = {
  getNotifications: function(grantApplications) {
    let today = new Date();
    let weekFromNow = new Date();
    weekFromNow.setDate(weekFromNow.getDate() + 7);
    var grantsDueWithinWeek = grantApplications.filter(
      a =>
        new Date(a.Display_Date) >= today &&
        new Date(a.Display_Date) <= weekFromNow
    );
    console.log(grantsDueWithinWeek);
  },

  getGrantApplicationStatuses: async function() {
    return await this.$store.getters
      .fetcher({
        query: `{
            grantApplicationStatuses{
              Grant_Application_Status_Id
              Title
            }
          }`
      })
      .then(res => res.data.grantApplicationStatuses);
  },

  getGrantApplicationStats: async function() {
    return await this.$store.getters
      .fetcher({
        query:
          `{
            grantApplicationStatsForUser(userId: ` +
          this.$store.getters.user.User_Id +
          `) {
              Application_Count
              Applications_Applied
              Applications_Won
              Applications_Lost
            }
          }`
      })
      .then(res => res.data.grantApplicationStatsForUser);
  },

  getGrantApplication: async function(applicationId) {
    return await this.$store.getters
      .fetcher({
        query:
          `{
            grantApplication(id:` +
          applicationId +
          `) 
            {
              Grant_Application_Id
              Grant {
                Grant_Id
                Title
                URL
              }
              Grant_Application_Status {
                Grant_Application_Status_Id
                Title
              }
              Grant_Application_Responses{
                Grant_Application_Response_Id
                Grant_Application_Response_Answers{
                  Grant_Application_Response_Answer_Id
                  Template_Response_Blank_Answer {
                    Template_Response_Blank_Answer_Id
                    Application_Template_Response_Id
                    Blank_Number
                    Answer
                  }
                }
                Application_Template_Response{
                  Application_Template_Response_Id
                  Response
                  Application_Template_Response_Category{
                    Application_Template_Response_Category_Id
                    Category
                    Summary
                    Application_Template_Response_Type
                  }
                  Template_Response_Blank_Answers(userId: ` +
          this.$store.getters.user.User_Id +
          `){
                    Template_Response_Blank_Answer_Id
                    Blank_Number
                    Answer
                  }
                }
              }
              Grant_Application_Budget{
                Grant_Application_Budget_Id
                Title
                Subtitle
                Budget
                Justification
                Grant_Application_Id
              }
            }
          }`
      })
      .then(res => res.data.grantApplication);
  },

  getGrantApplicationsForUser: async function(showHidden = true) {
    var showHiddenQuery = showHidden ? "" : ", showHidden: " + false;
    return await this.$store.getters
      .fetcher({
        query:
          `{
      grantApplicationsForUser(userId: ` +
          this.$store.getters.user.User_Id +
          showHiddenQuery +
          `) {
        Grant_Application_Id
        Is_Hidden
        Grant {
          Grant_Id
          Title
          Description
          Organization
          Award_Amount
          Application_Deadline
          URL
          Teaching_Grade
          Teaching_Subject
          Award_Level
          Date_Added
          Eligibility
          Requires_501C3
        }
        Grant_Application_Status {
          Grant_Application_Status_Id
          Title
        }
      }
    }`
      })
      .then(res => {
        return res.data.grantApplicationsForUser;
      });
  },

  hideGrantApplication: async function(applicationToHide) {
    return await this.$store.getters
      .fetcher({
        query: `mutation($grantApplicationId: Int!){
        HideGrantApplication(grantApplicationId: $grantApplicationId)
        {
          Grant_Application_Id
        }
      }`,
        variables: {
          grantApplicationId: parseInt(applicationToHide.Grant_Application_Id)
        }
      })
      .then(() => {
        return applicationToHide;
      });
  },

  unhideGrantApplication: async function(applicationToUnhide) {
    return await this.$store.getters
      .fetcher({
        query: `mutation($grantApplicationId: Int!){
          UnhideGrantApplication(grantApplicationId: $grantApplicationId)
        {
          Grant_Application_Id
        }
      }`,
        variables: {
          grantApplicationId: parseInt(applicationToUnhide.Grant_Application_Id)
        }
      })
      .then(() => {
        return applicationToUnhide;
      });
  },

  updateGrantApplicationStatus: async function(
    applicationToUpdate,
    newStatusId
  ) {
    return await this.$store.getters
      .fetcher({
        query: `mutation($grantApplicationId: Int!, $grantApplicationStatusId: Int!){
        UpdateGrantApplicationStatus(grantApplicationId: $grantApplicationId, grantApplicationStatusId: $grantApplicationStatusId)
        {
          Grant_Application_Id
        }
      }`,
        variables: {
          grantApplicationId: parseInt(
            applicationToUpdate.Grant_Application_Id
          ),
          grantApplicationStatusId: parseInt(newStatusId)
        }
      })
      .then(() => {
        applicationToUpdate.Grant_Application_Status.Grant_Application_Status_Id = newStatusId;
        return applicationToUpdate;
      });
  },

  removeGrantApplication: async function(applicationToRemove) {
    var res = await this.$store.getters.fetcher({
      query: `mutation($grantApplicationId: Int!){
        RemoveGrantApplication(grantApplicationId: $grantApplicationId)
      }`,
      variables: {
        grantApplicationId: parseInt(applicationToRemove.Grant_Application_Id)
      }
    });
    //remove saved grant id from the user object
    var user = Object.assign({}, this.$store.getters.user);
    var userDeletedIndex = user.Saved_Grants.findIndex(
      g => g.Grant_Id == applicationToRemove.Grant.Grant_Id
    );
    user.Saved_Grants.splice(userDeletedIndex, 1);

    return res.data;
  },

  createGrantApplicationResponse: async function(
    grantApplicationId,
    applicationTemplateResponseId
  ) {
    return await this.$store.getters
      .fetcher({
        query:
          `mutation($applicationTemplateResponseId: Int!, $grantApplicationId: Int!) {
        CreateGrantApplicationResponse(applicationTemplateResponseId: $applicationTemplateResponseId, grantApplicationId: $grantApplicationId){
          Grant_Application_Response_Id
          Grant_Application_Response_Answers{
            Grant_Application_Response_Answer_Id
            Template_Response_Blank_Answer {
              Template_Response_Blank_Answer_Id
              Application_Template_Response_Id
              Blank_Number
              Answer
            }
          }
          Application_Template_Response{
            Application_Template_Response_Id
            Response
            Application_Template_Response_Category{
              Application_Template_Response_Category_Id
              Category
              Summary
              Application_Template_Response_Type
            }
            Template_Response_Blank_Answers(userId: ` +
          this.$store.getters.user.User_Id +
          `){
              Template_Response_Blank_Answer_Id
              Blank_Number
              Answer
            }
          }
        }
      }`,
        variables: {
          applicationTemplateResponseId: parseInt(
            applicationTemplateResponseId
          ),
          grantApplicationId: parseInt(grantApplicationId)
        }
      })
      .then(res => res.data.CreateGrantApplicationResponse);
  },

  createGrantApplicationResponseAnswer: async function(
    grantApplicationResponseId,
    templateResponseBlankAnswer
  ) {
    return await this.$store.getters
      .fetcher({
        query: `mutation($grantApplicationResponseId: Int!, $templateResponseBlankAnswerId: Int!) {
        CreateGrantApplicationResponseAnswer(grantApplicationResponseId: $grantApplicationResponseId, templateResponseBlankAnswerId: $templateResponseBlankAnswerId){
          Grant_Application_Response_Answer_Id
        }
      }`,
        variables: {
          grantApplicationResponseId: parseInt(grantApplicationResponseId),
          templateResponseBlankAnswerId: parseInt(
            templateResponseBlankAnswer.Template_Response_Blank_Answer_Id
          )
        }
      })
      .then(res => {
        var createdGrantApplicationResponseAnswer = {
          Grant_Application_Response_Answer_Id:
            res.data.CreateGrantApplicationResponseAnswer
              .Grant_Application_Response_Answer_Id,
          Template_Response_Blank_Answer: {
            Answer: templateResponseBlankAnswer.Answer,
            Blank_Number: templateResponseBlankAnswer.Blank_Number,
            Template_Response_Blank_Answer_Id:
              templateResponseBlankAnswer.Template_Response_Blank_Answer_Id
          }
        };
        return createdGrantApplicationResponseAnswer;
      });
  },

  updateGrantApplicationResponseAnswer: async function(
    grantApplicationResponseAnswerId,
    templateResponseBlankAnswer
  ) {
    return await this.$store.getters
      .fetcher({
        query: `mutation($grantApplicationResponseAnswerId: Int!, $templateResponseBlankAnswerId: Int!) {
        UpdateGrantApplicationResponseAnswer(grantApplicationResponseAnswerId: $grantApplicationResponseAnswerId, templateResponseBlankAnswerId: $templateResponseBlankAnswerId){
          Grant_Application_Response_Answer_Id
        }
      }`,
        variables: {
          grantApplicationResponseAnswerId: parseInt(
            grantApplicationResponseAnswerId
          ),
          templateResponseBlankAnswerId: parseInt(
            templateResponseBlankAnswer.Template_Response_Blank_Answer_Id
          )
        }
      })
      .then(res => {
        var updatedGrantApplicationResponseAnswer = {
          Grant_Application_Response_Answer_Id:
            res.data.UpdateGrantApplicationResponseAnswer
              .Grant_Application_Response_Answer_Id,
          Template_Response_Blank_Answer: {
            Answer: templateResponseBlankAnswer.Answer,
            Blank_Number: templateResponseBlankAnswer.Blank_Number,
            Template_Response_Blank_Answer_Id:
              templateResponseBlankAnswer.Template_Response_Blank_Answer_Id
          }
        };
        return updatedGrantApplicationResponseAnswer;
      });
  },

  removeGrantApplicationResponse: async function(grantApplicationResponseId) {
    return await this.$store.getters
      .fetcher({
        query: `mutation($grantApplicationResponseId: Int!) {
          RemoveGrantApplicationResponse(grantApplicationResponseId: $grantApplicationResponseId)
      }`,
        variables: {
          grantApplicationResponseId: parseInt(grantApplicationResponseId)
        }
      })
      .then(res => res.data.RemoveGrantApplicationResponse);
  },

  createGrantApplicationBudget: async function(grantApplicationBudgetToCreate) {
    return await this.$store.getters
      .fetcher({
        query: `mutation($title: String, $subtitle: String, $budget: String!, $justification: String, $grantApplicationId: Int!) {
        CreateGrantApplicationBudget(title: $title, subtitle: $subtitle, budget: $budget, justification: $justification, grantApplicationId: $grantApplicationId){
          Grant_Application_Budget_Id
        }
      }`,
        variables: {
          title: grantApplicationBudgetToCreate.Title,
          subtitle: grantApplicationBudgetToCreate.Subtitle,
          budget: JSON.stringify(grantApplicationBudgetToCreate.Budget),
          justification: grantApplicationBudgetToCreate.justification,
          grantApplicationId: parseInt(
            grantApplicationBudgetToCreate.Grant_Application_Id
          )
        }
      })
      .then(res => {
        grantApplicationBudgetToCreate.Grant_Application_Budget_Id =
          res.data.Grant_Application_Budget_Id;
        return grantApplicationBudgetToCreate;
      });
  },

  updateGrantApplicationBudget: async function(grantApplicationBudgetToUpdate) {
    return await this.$store.getters
      .fetcher({
        query: `mutation($grantApplicationBudgetId: Int!, $title: String, $subtitle: String, $budget: String!, $justification: String, $grantApplicationId: Int!) {
        UpdateGrantApplicationBudget(grantApplicationBudgetId: $grantApplicationBudgetId, title: $title, subtitle: $subtitle, budget: $budget, justification: $justification, grantApplicationId: $grantApplicationId){
          Grant_Application_Budget_Id
        }
      }`,
        variables: {
          grantApplicationBudgetId: parseInt(
            grantApplicationBudgetToUpdate.Grant_Application_Budget_Id
          ),
          title: grantApplicationBudgetToUpdate.Title,
          subtitle: grantApplicationBudgetToUpdate.Subtitle,
          budget: JSON.stringify(grantApplicationBudgetToUpdate.Budget),
          justification: grantApplicationBudgetToUpdate.justification,
          grantApplicationId: parseInt(
            grantApplicationBudgetToUpdate.Grant_Application_Id
          )
        }
      })
      .then(res => {
        grantApplicationBudgetToUpdate.Grant_Application_Budget_Id =
          res.data.Grant_Application_Budget_Id;
        return grantApplicationBudgetToUpdate;
      });
  }
};

export { grantApplication };
